import styled from '@emotion/styled';

import { customPalette } from '../../../styles/theme';

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 0;
  width: 100%;
  box-sizing: border-box;
  position: relative;
`;

export const Title = styled.h1`
  color: ${customPalette.grey.main};
  font-size: 32px;
  font-weight: 700;
  line-height: 150%;
  margin: 0;
`;

interface BPContainerProps {
  isListOpen: boolean;
  hasActiveBP: boolean;
}

export const BPContainer = styled.div<BPContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 345px;
  z-index: 1000;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  max-height: ${({ isListOpen }) => (isListOpen ? '100%' : '170px')};
  background: ${({ isListOpen }) =>
    isListOpen ? customPalette.accent.main : 'none'};
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 24px 0 24px;
  @media (max-width: 1200px) {
    display: none;
  }
`;
